







































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {IAuthService} from '@/services/IAuth.service';
import {ISystemOsService} from '@/services/system/IOs.service';
import {ISettingsService} from '@/services/settings/ISettings.service';
import {Setting, Theme} from '@/services/settings/Settings.types';
import {IApiService} from '@/services/IApi.service';

import {ApiStore} from '@/store/Api.store';
import {AuthStore} from '@/store/Auth.store';
import {AppStore} from '@/store/App.store';
import {MessagingStore} from '@/store/Messaging.store';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';
import Notifications from '@/components/Notifications/Notifications.vue';

@Component({
  components: {Notifications},
})
export default class LoginPage extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  @Inject(Symbol.for('IAuthService'))
  private authService!: IAuthService;

  @Inject(Symbol.for('ISystemOsService'))
  private systemOsService!: ISystemOsService;

  @Inject(Symbol.for('ISettingsService'))
  private settingsService!: ISettingsService;

  private apiStore: ApiStore = getModule(ApiStore, this.$store);

  @Inject(Symbol.for('AuthStore'))
  private authStore!: AuthStore;

  @Inject(Symbol.for('MessagingStore'))
  private messagingStore!: MessagingStore;

  private appStore: AppStore = getModule(AppStore, this.$store);

  private remote: string = '';
  private secured: boolean = false;
  private username: string = '';
  private password: string = '';

  private authenticating: boolean = false;
  private dialog: boolean = false;

  private checkingGatewayAccess: boolean = false;

  private Setting = Setting;
  private Theme = Theme;

  private async mounted() {

    await this.apiStore.loadRemote();
    await this.apiStore.loadSecured();
    if (this.apiStore.Remote) {
      this.remote = this.apiStore.Remote;
    }
    this.secured = this.apiStore.Secured;
  }

  private async login() {
    try {
      this.authenticating = true;
      this.logger.info(`Logging in with user '${this.username}'`);
      await this.authStore.login(this.username, this.password);
    } catch (error) {
      this.logger.error(`Failed to log in with user '${this.username}'`, error);
      Notify.Error(this.logger, 'Wrong username or password', error);
      return;
    } finally {
      this.authenticating = false;
    }

    if (this.apiStore.Remote && this.authStore.Token) {

      try {
        this.logger.debug(`Connecting messaging...`);
        await this.messagingStore.connect(this.apiStore.Remote, this.apiStore.Secured, this.authStore.Token);
        this.appStore.setMessagingStatus(this.messagingStore.Status);
      } catch (error) {
        this.logger.error(`Failed to connect messaging`, error);
      }
    }

    if (this.$route.params.nextUrl != null) {
      this.logger.debug(`Redirecting to '${this.$route.params.nextUrl}'`);
      await this.$router.push(this.$route.params.nextUrl);
    } else {
      this.logger.debug(`Redirecting to dashboard`);
      await this.$router.push({name: 'dashboard'});
    }
  }

  private async setRemote() {
    try {
      this.checkingGatewayAccess = true;

      this.logger.debug(`Setting remote to '${this.remote}' with TLS='${this.secured}'`);

      this.apiStore.setRemote(this.remote);
      this.apiStore.setSecured(this.secured);
      this.apiService.configure(this.remote, this.secured);

      if (this.apiStore.ConfigurableRemote) {
        this.settingsService.set(Setting.RemoteAddress, this.apiStore.Remote);
        this.settingsService.set(Setting.Secured, this.apiStore.Secured);
      }

      const available = await this.apiStore.checkAvailable();
      this.appStore.setApiAvailable(available);

      if (available) {
        Notify.Success(this.logger, `Gateway is reachable`);
      } else {
        Notify.Error(this.logger, `Gateway is not reachable`);
      }
    } finally {
      this.checkingGatewayAccess = false;
    }
  }
}
